import React from 'react';
import { Container } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getPerformaOne, getPerformaOneSuccess, getPerformaOneFailure,resetGetPerformaOneState } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    chiefComplications: {
        type: 'text',
        placeholder: 'Chief Complications',
        label: 'Chief Complications'
    },
    durationOfSymptoms: {
        type: 'text',
        placeholder: 'Duration Symptoms',
        label: 'Duration Symptoms',
    },
    familyHistory: {
        type: 'text',
        placeholder: 'Family History',
        label: 'Family History',
    },
    height: {
        type: 'number',
        placeholder: 'Height',
        label: 'Height(cm)'
    },
    weight: {
        type: 'number',
        placeholder: 'Weight',
        label: 'Weight(kg)',
    },
    BMI: {
        type: 'number',
        placeholder: 'BMI',
        label: 'BMI',
    },
    referingPhysician: {
        type: 'text',
        placeholder: 'Refering Physician',
        label: 'Refering Physician'
    },
    previousRecordOfDrugTreatment: {
        type: 'text',
        placeholder: 'Previous record of drug treatment',
        label: 'Previous record of drug treatment'
    },
    deformity: {
        type: 'text',
        placeholder: 'deformity',
        label: 'Deformity'
    },
    bonePain: {
        type: 'text',
        placeholder: 'bone pain',
        label: 'Bone Pain'
    },
    backache: {
        type: 'text',
        placeholder: 'backache',
        label: 'Bach Ache'
    },
    facialAsymmetry: {
        type: 'text',
        placeholder: 'Facial Asymmetry',
        label: 'Facial Asymmetry'
    },
    fracture: {
        type: 'text',
        placeholder: 'fracture',
        label: '1st fracture'
    },
    siteOfFracture: {
        type: 'text',
        placeholder:  'Site of Fracture',
        label: 'Site of Fracture'
    },
    numberOfFracture: {
        type: 'text',
        placeholder: 'Number Of Fracture',
        label: 'Number Of Fracture'
    },
    nonUnion: {
        type: 'text',
        placeholder: 'Non Union',
        label: 'Non Union'
    },
    malunio: {
        type: 'text',
        placeholder: 'Malunio',
        label: 'Malunio'
    },
    compressionFracture: {
        type: 'text',
        placeholder: 'Compression Fracture',
        label: 'Compression Fracture'
    },
    blueSclera: {
        type: 'text',
        placeholder: 'Blue Sclera',
        label: 'Blue Sclera'
    },
    dentinogenesisImperfecta: {
        type: 'text',
        placeholder: 'Dentinogenesis Imperfecta',
        label: 'Dentinogenesis Imperfecta'
    },
    teethLoss: {
        type: 'text',
        placeholder: 'Teeth Loss',
        label: 'Teeth Loss'
    },
    deafness: {
        type: 'text',
        placeholder: 'Deafness',
        label: 'Deafness'
    },
    headache: {
        type: 'text',
        placeholder: 'Headache',
        label: 'Headache'
    },
    cafe_au_lait_macules: {
        type: 'text',
        placeholder: 'cafe_au_lait_macules',
        label: 'Café-au-lait macules'
    },
    difficultBite: {
        type: 'text',
        placeholder: 'Difficult Bite',
        label: 'Difficult Bite'
    },
    increaseSkullSize: {
        type: 'text',
        placeholder: 'Increase Skull Size',
        label: 'Increase Skull Size'
    },
    skinThickening: {
        type: 'text',
        placeholder: 'Skin Thickening',
        label: 'Skin Thickening'
    },
    tuftingOfPhalanges: {
        type: 'text',
        placeholder: 'Tufting Of Phalanges',
        label: 'Tufting Of Phalanges'
    },
}


class PerformaOne extends React.Component {

    componentDidMount() {
        this.props.getPerformaOne(serverUrls.performaone + this.props.id + '/');
    }
    componentWillUnmount() {
        this.props.resetGetPerformaOneState();
      }

    render() {
        var url = serverUrls.performaone + this.props.id + '/';
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>Performa One</h4>
                <br/>
                <CreateFormInput isPost={false} buttonName="Save" url={url} formName="getPerformaOne" inputs={formInputs} />
                <br/>
                <br/>
            </Container>
        )
    }
}

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        getPerformaOne: (url) => {
            dispatch(getPerformaOne({loading: true}));
            axios.get(url).then((res)=>{
                dispatch(getPerformaOneSuccess({loading: false, success: res.data.success, data: res.data}));
            }).catch((err)=>{
                dispatch(getPerformaOneFailure({loading: false}));
            });
        },
        resetGetPerformaOneState: () => {
            dispatch(resetGetPerformaOneState());
          },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PerformaOne);